import { useArtworkDrawer } from 'contexts/ArtworkDrawerContext';

/* artwork */
import { NewArtwork } from 'drawers/artwork/NewArtwork';
import { ArtworkFiles } from 'drawers/artwork/ArtworkFiles';
import { ArtworkLayouts } from 'drawers/artwork/ArtworkLayouts';
import { SaveArtwork } from 'drawers/artwork/SaveArtwork';

export const useArtworkDrawers = () => {
  const { openDrawer, closeDrawer } = useArtworkDrawer();

  /* artwork */
  const openDrawerNewArtwork = () => {
    openDrawer({ component: NewArtwork });
  };
  const openDrawerArtworkFiles = () => {
    openDrawer({ component: ArtworkFiles, allowClickOutsideClose: true });
  };
  const openDrawerArtworkLayouts = () => {
    openDrawer({ component: ArtworkLayouts });
  };
  const openDrawerSaveArtwork = () => {
    openDrawer({ component: SaveArtwork, allowClickOutsideClose: true });
  };
  const closeDrawerArtworkFiles = () => {
    closeDrawer({ component: ArtworkFiles });
  };

  return {
    /* artwork */
    openDrawerNewArtwork,
    openDrawerArtworkFiles,
    openDrawerArtworkLayouts,
    openDrawerSaveArtwork,
    closeDrawerArtworkFiles,
  };
};
